"use client";
import { Row } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import { opportunitySchema } from "../table-data/schema";
import { useRouter } from "next/navigation";
import { useState } from "react";
import RightViewModalNoTrigger from "@/components/modals/right-view-notrigger";
import { UpdateOpportunityForm } from "../components/UpdateOpportunityForm";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const router = useRouter();
  const opportunity = opportunitySchema.parse(row.original);
  const [updateOpen, setUpdateOpen] = useState(false);

  // Log the value of opportunity.assigned_leadsIDs
  console.log("Assigned Lead ID:", opportunity.assigned_leadsIDs);

  return (
    <>
      <Button
        variant="outline"
        onClick={() => router.push(`/crm/leads/${opportunity?.assigned_leadsIDs}`)}
      >
        View 
      </Button>
    </>
  );
}